import requestAnimationFrame from 'raf';
var cancelAnimationFrame = requestAnimationFrame.cancel;
export function setTimeout(callback, delay) {
  var startedAt = Date.now();
  var animationFrame = requestAnimationFrame(tick);

  function tick() {
    if (Date.now() - startedAt >= delay) {
      callback();
    } else {
      animationFrame = requestAnimationFrame(tick);
    }
  }

  return {
    clear: function clear() {
      return cancelAnimationFrame(animationFrame);
    }
  };
}
export function clearTimeout(timeout) {
  if (timeout) {
    timeout.clear();
  }
}
//# sourceMappingURL=index.js.map